module.exports = __webpack_public_path__ + "img/self-care.c6290def.png";